import {atom} from 'jotai';
import {userinfo} from '../Services/auth';
import {getRoleList} from '../Services/user';
import {makeDict} from '../Utils/common';

export const userStore = atom(async get => {
    try {
        return await userinfo();
    } catch (e) {
        return {no: '未知用户'};
    }
});

// 角色列表
export const RoleListAtom = atom(async () => {
    const data = await getRoleList();
    return makeDict(data.map(item => ({label: item.roleName, value: item.id})));
});
